import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ROUTES } from './routes';
import './App.css'
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

const App = () => {
  const router = createBrowserRouter(ROUTES)
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID} >
      <RouterProvider router={router} />
    </GoogleOAuthProvider>
  )
}

export default App;